module.exports = __webpack_public_path__ + "static/media/Medcare Paediatric Speciality Clinic.846bae82.jpg";